import api from './api';

const vaultsqlparametersService = {
  // Get all vault SQL parameters with optional filters
  getAllVaultSqlParameters: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.vaultsqlid) {
      params.append('vaultsqlid', filters.vaultsqlid);
    }

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/vaultsqlparameters?${queryString}` : '/vaultsqlparameters';

    const response = await api.get(url);
    return response.data;
  },

  // Get a single vault SQL parameter by ID
  getVaultSqlParameterById: async (id) => {
    const response = await api.get(`/vaultsqlparameters/${id}`);
    return response.data;
  },

  // Create a new vault SQL parameter
  createVaultSqlParameter: async (parameterData) => {
    const response = await api.post('/vaultsqlparameters', parameterData);
    return response.data;
  },

  // Update an existing vault SQL parameter
  updateVaultSqlParameter: async (id, parameterData) => {
    const response = await api.put(`/vaultsqlparameters/${id}`, parameterData);
    return response.data;
  },

  // Delete a vault SQL parameter
  deleteVaultSqlParameter: async (id) => {
    const response = await api.delete(`/vaultsqlparameters/${id}`);
    return response.data;
  }
};

export default vaultsqlparametersService;
